import { render, staticRenderFns } from "./WguAppTemplate.vue?vue&type=template&id=fe2345b4&"
import script from "./WguAppTemplate.vue?vue&type=script&lang=js&"
export * from "./WguAppTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports